import { render, staticRenderFns } from "./position_level_edit.vue?vue&type=template&id=fd0804d6&scoped=true"
import script from "./position_level_edit.vue?vue&type=script&lang=js"
export * from "./position_level_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0804d6",
  null
  
)

export default component.exports